import {
    sendEvent,
    type THeaderNavLinkEventName,
    type THeaderNavSectionEventName,
} from '@core/analytics'

export type TNavPlacement = 'header' | 'hamburger_menu'

export const navLinkClick = (
    placement: TNavPlacement,
    name: THeaderNavLinkEventName | undefined,
): (() => void) | undefined =>
    name ? () => sendEvent({ name, payload: { placement } }) : undefined

export type TUserMenuEventName = 'menu_insights_click'

export const userMenuClick = (name: TUserMenuEventName | undefined): (() => void) | undefined =>
    name ? () => sendEvent({ name, payload: {} }) : undefined

export const navSectionClick = (
    placement: TNavPlacement,
    name: THeaderNavSectionEventName | undefined,
): (() => void) | undefined =>
    name && placement === 'hamburger_menu'
        ? () => sendEvent({ name, payload: { placement } })
        : undefined
